import { createSlice } from "@reduxjs/toolkit";
import { getCarts , addCart , editCart, DeleteCartItem } from "./thunk"; // Import the async thunks

const initialState = {
  cart: null,
  Carts:[],
  loading: false,
  error: null,
};

const cartsSlice = createSlice({
  name: "cartsSlice",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder

    // login
      .addCase(addCart.pending, (state) => {
        state.loading = true;
      })
      .addCase(addCart.fulfilled, (state, action) => {
        state.loading = false;
        state.cart = action.payload
      })
      .addCase(addCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });


    builder
    .addCase(DeleteCartItem.fulfilled, (state, action) => {
      const deletedItemId = action.payload
      state.Carts = state.Carts.filter(el=>el.cart_srl != deletedItemId)
    })

    builder

      .addCase(getCarts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCarts.fulfilled, (state, action) => {
        state.loading = false;
        state.Carts = action.payload
      })
      .addCase(getCarts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

  },
  

});

export default cartsSlice.reducer;
